import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PreviousRouteService {
  storageName: string = 'prevURLS';
  constructor() { }


  saveCurrentURL(url: string) {
    if (!url) return;
    const prevURLs = typeof window !== 'undefined' ? localStorage.getItem(this.storageName) : '';
    const prevURLsJSON = prevURLs ? JSON.parse(prevURLs) || [] : [];
    const lastPrev = [prevURLsJSON[prevURLsJSON.length - 1]];
    if (typeof window !== 'undefined') localStorage.setItem(this.storageName, JSON.stringify([...lastPrev, ...[url]]));
  }


  getPreviousURL() {
    const prevURLs = typeof window !== 'undefined' ? localStorage.getItem(this.storageName) : '';
    const prevURLsJSON = prevURLs ? JSON.parse(prevURLs) || [] : [];
    return prevURLsJSON?.[0];
  }

  getSubSedary(url: string) {
    if (url.includes('/fahes')) {
      return 'fahes';
    } else if (url.includes('/qjet')) {
      return 'qjet';      
    }else {
      return 'woqod';
    }


    // return url.indexOf('/fahes') !== -1 ? 'fahes' : 'woqod';
    // woqod
    // fahes
  }

}
